import APIContext, { APIProvider, useAPI } from './APIProvider';
import AuthContext, { AuthProvider, useAuth } from './AuthContext';
import ThemeContext, { ThemeProvider, useTheme } from './ThemeContext';
import MessagesContext, { MessagesProvider, useMessages, MessageStatus } from './MessagesContext';
import NotificationContext, { NotificationProvider, useNotifications } from './NotificationContext';

const CONTEXTS = {
  APIContext,
  APIProvider,
  useAPI,
  AuthContext,
  AuthProvider,
  useAuth,
  ThemeContext,
  ThemeProvider,
  useTheme,
  MessagesContext,
  MessagesProvider,
  useMessages,
  MessageStatus,
  NotificationContext,
  NotificationProvider,
  useNotifications,
};

export { CONTEXTS };
